// src/ApiService/incidentsApi.js
export const incidentsApi = (api) => ({
  // list/search
  list: (params) => api.get(`/Incidents`, params),

  // detail
  get: (incidentId) => api.get(`/Incidents/${incidentId}`),

  // create/update
  create: (payload) => api.post(`/Incidents`, payload),
  update: (incidentId, payload) => api.put(`/Incidents/${incidentId}`, payload),

  // workflow
  submit: (incidentId, payload) => api.post(`/Incidents/${incidentId}/submit`, payload ?? {}),
  assign: (incidentId, payload) => api.post(`/Incidents/${incidentId}/assign`, payload),
  actionRequired: (incidentId, payload) => api.post(`/Incidents/${incidentId}/action-required`, payload),
  resolve: (incidentId, payload) => api.post(`/Incidents/${incidentId}/resolve`, payload),
  archive: (incidentId, payload) => api.post(`/Incidents/${incidentId}/archive`, payload ?? {}),
  reopen: (incidentId, payload) => api.post(`/Incidents/${incidentId}/reopen`, payload ?? {}),

  // actions
  addAction: (incidentId, payload) => api.post(`/Incidents/${incidentId}/actions`, payload),
  updateAction: (incidentId, actionId, payload) => api.put(`/Incidents/${incidentId}/actions/${actionId}`, payload),
  completeAction: (incidentId, actionId, payload) =>
    api.post(`/Incidents/${incidentId}/actions/${actionId}/complete`, payload ?? {}),

  // attachments
  uploadAttachment: (incidentId, formData) =>
    api.post(`/Incidents/${incidentId}/attachments`, formData),
  deleteAttachment: (incidentId, attachmentId) =>
    api.delete(`/Incidents/${incidentId}/attachments/${attachmentId}`),
});
